import axios from 'axios';
import JSONbig from 'json-bigint';

const API_KEY = 'jhTKd466Eitkpr4cE8NiyYLE37XajreAhNuQJSdF';

export default {
    get:async(url, params) => {
        // パラメータ送信
        axios.defaults.headers.common = {
            'App-Key': API_KEY,
            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        }

        axios.defaults.transformResponse = [function (data) {
            return JSONbig.parse(data);
        }];

        return await axios.get(url, params);
    },

    post:async(url, params) => {
        // パラメータ送信
        axios.defaults.headers.common = {
            'App-Key': API_KEY,
            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        }

        axios.defaults.transformResponse = [function (data) {
            return JSONbig.parse(data);
        }];

        return await axios.post(url, params);
    },

    put:async(url, params) => {
        // パラメータ送信
        axios.defaults.headers.common = {
            'App-Key': API_KEY,
            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        }

        axios.defaults.transformResponse = [function (data) {
            return JSONbig.parse(data);
        }];

        return await axios.put(url, params);
    },

    all:async(url, params) => {
        // パラメータ送信
        axios.defaults.headers.common = {
            'App-Key': API_KEY,
            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        }

        axios.defaults.transformResponse = [function (data) {
            return JSONbig.parse(data);
        }];

        return await axios.all(url, params);
    }
}